<template>
	<p v-if="isSlider && label" :class="['text-[9px]/[10px] !mb-3 font-medium', hasFullCoverImage && '!text-white']">
		{{ label }}
	</p>
	<figcaption
		v-else-if="isFigcaption && label"
		class="!py-1.5 uppercase !px-2 text-[9px]/[10px] !text-black !mb-3 font-medium bg-neutral-200"
	>
		{{ label }}
	</figcaption>
	<p
		v-else-if="label"
		class="!py-1.5 absolute top-3 left-3 uppercase text-sm/[14px] !px-2 !text-black !mb-3 font-medium bg-neutral-200"
	>
		{{ label }}
	</p>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps({
	item: {
		type: Object,
		required: true,
	},
	isFigcaption: {
		type: Boolean,
		default: false,
	},
	isSlider: {
		type: Boolean,
		default: false,
	},
	saleInformation: {
		type: Array,
	},
})

const hasFullCoverImage = computed(() => {
	return props.item?.hasFullCoverImage ?? false
})
const sale = computed(() => {
	const saleArr = props.saleInformation ?? []
	return saleArr.find((s) => s.qualifying_skus.includes(props.item.itemCode) && s.can_purchase)
})
const label = computed(() => {
	const { isReleasedForCustomer, outOfStock, isLimitedEdition, lowStock, labelText, isNewRelease } = props.item

	let showPendingLabelText // used for coming soon only
	if (props.item.itemRaw) {
		showPendingLabelText = !props.item.itemRaw.LabelEnum
	} else {
		showPendingLabelText = props.item.showPendingLabelText
	}

	if (!isReleasedForCustomer) {
		return labelText && showPendingLabelText ? `${labelText} Coming Soon` : 'Coming Soon'
	}
	if (outOfStock) {
		if (isLimitedEdition) return 'Sold Out' // not coming back
		return 'Out Of Stock' // coming back
	}
	if (lowStock) return 'Low Stock'
	if (sale.value) return sale.value.product_tag
	if (labelText) return labelText // custom label driven from admin
	if (isNewRelease) return 'New'
	return null
})
</script>
